<template>
	<MonitorLayoutTemplate
        :table_title="table_title"
    >
        <template v-slot:datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                :allow_hour_list="allow_hour_list"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template v-slot:data_table="slot_props">
            <QpeDatatable
                class="mpb_monitor"
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :props_date="date"
                :props_time="time"
                :search="slot_props.search"
                :should_show_raw_html_header="should_show_raw_html_header"
                :custom_header="true"
                :show_table_border="true"
                :show_download_pdf_btn="false"
                :show_download_png_btn="is_show_download_png_btn"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            >
                <template v-slot:table_description>
                    <span>
                        說明：<br>
                        1.警示條件：表示海域內風力或浪高之警戒值達40%以上。<br>
                        紅燈: <span class="description-dot" style="background: #FF0000"/>：達警示標準<br>
                        綠燈: <span class="description-dot" style="background: #00FF00"/>：未達警示標準<br>   
                        --: 無資料<br>
                    </span>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
import { redirect_monitor_table_ajax } from '@/utils/monitor/monitor.js'
import { monitor_mixin } from '@/utils/monitor/monitor_mixin.js'
import { alert_color_style_mapping } from '@/config/monitor_config.js'
import cloneDeep from 'lodash/cloneDeep'
import { TABLE_VALUE_TEXT_MAPPING } from '@/config/monitor_config.js'
import MonitorLayoutTemplate from '@/components/monitor/_tool/layout_template.vue'
import QpeDatetime from '@/components/monitor/qpe_datetime.vue'
import QpeDatatable from './../qpe_datatable.vue'

export default {
    name: 'mpb_monitor',

    components: {
        MonitorLayoutTemplate,
        QpeDatetime,
        QpeDatatable,
    },

    props: {
        default_value: {
            type: Number,
            required: true,
        },
    },

    mixins: [monitor_mixin],

    data() {
        return {
            header: [],
            immutable_table_data: [],
            table_data: [],
            error_text: '',
            allow_hour_list: [2, 8, 14, 20],
            should_show_raw_html_header: [],
        }
    },

    computed: {
        table_title() {
            return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
        },
        column_name() {
            const obj = {
                150: '燈號',
                151: '百分比',
            }
            return obj[this.default_value]
        },
        table_type() {
            const obj = {
                150: 'light',
                151: 'percent',
            }
            return obj[this.default_value]
        },
        is_show_download_png_btn() {
            const obj = {
                150: true, //海域海況警示燈號資訊
                151: false, //警戒網格數百分比資訊
            }
            return obj[this.default_value]
        },
    },

    created() {
        redirect_monitor_table_ajax.call(this, this.default_value)
    },

    methods: {
        generate_table_data(data, header) {
            this.immutable_table_data = data
            let temp_table_data
            ;[temp_table_data, this.header] = this.reconstruct_table_data({ ...data }, [...header])

            this.table_data = this.reconstruct_alert_content(temp_table_data)

            console.log('table_data', this.table_data)
        },

        reconstruct_table_data(data, origin_header) {
            const table_data = []
            const standby_area_list = Object.keys(data['QPESUMS'])
            let return_header = origin_header

            Object.keys(data).forEach((first_header) => {
                if (first_header === 'QPESUMS') {
                    //區域資料, 非時間資料
                    Object.keys(data[first_header]).forEach((standby_area_key) => {
                        if (standby_area_list.includes(standby_area_key)) {
                            table_data.push({
                                海域管轄區: standby_area_key,
                                編號: data[first_header][standby_area_key],
                            })
                        }
                    })
                } else {
                    // 時間資料 first_header = 20250320 02CST
                    data[first_header]
                        // .sort((a, b) => {
                        //     return a.initime - b.initime
                        // })
                        .forEach((datum, index) => {
                            const row_index = standby_area_list.indexOf(datum['海域管轄區'])
                            table_data[row_index][first_header] = datum[this.column_name]

                            const second_header = index
                            return_header = this.concat_return_header(
                                return_header,
                                first_header,
                                second_header,
                                origin_header.length
                            )
                        })
                }
            })

            return [table_data, return_header]
        },

        reconstruct_alert_content(data_array) {
            return cloneDeep(data_array).map((datum) => {
                const be_concat_object = this.should_show_raw_html_header.reduce((accum, html_header) => {
                    const value = datum[html_header]
                    const color = alert_color_style_mapping[value]

                    if (this.table_type === 'percent') {
                        const column_class = value >= 40 ? 'text-warning' : ''
                        return {
                            ...accum,
                            ...{
                                [html_header]: [
                                    {
                                        html: `<span class="${column_class}"> ${value}% </span>`,
                                        center: true,
                                    },
                                ],
                            },
                        }
                    } else if (color && this.table_type === 'light') {
                        return {
                            ...accum,
                            ...{
                                [html_header]: [
                                    {
                                        html: `<span class="dot" style="background: ${color}"/>`,
                                        center: true,
                                    },
                                ],
                            },
                        }
                    }

                    return {
                        ...accum,
                        ...{
                            [html_header]: [
                                {
                                    html: `<span> -- </span>`,
                                    center: true,
                                },
                            ],
                        },
                    }
                }, {})

                return { ...datum, ...be_concat_object }
            })
        },

        concat_return_header(return_header, first_header, second_header, origin_header_length) {
            const header_value = `${first_header}`
            this.should_show_raw_html_header.push(header_value)
            const date = `${first_header.substring(4, 6)}月${first_header.substring(6, 8)}日`
            const timez = `${first_header.substring(9, 11)}CST`

            //第一個要負責產th
            if (return_header.length === origin_header_length) {
                return_header = return_header.concat({
                    order: return_header.length,
                    value: header_value,
                    text: '預報燈號警示(預報時間)',
                    second_text: date,
                    third_text: timez,
                })
            }
            //每一輪的第一個要負責產th
            else if (second_header === 0) {
                return_header = return_header.concat({
                    order: return_header.length,
                    value: header_value,
                    second_text: date,
                    third_text: timez,
                })
            }
            return return_header
        },
    },
}
</script>

<style>
.mpb_monitor .v-data-table__wrapper {
    height: 65vh;
    overflow-y: scroll;
}
.mpb_monitor th {
    position: sticky;
    height: 2em;
    padding: 0 0.5em !important;
    white-space: nowrap;
    text-align: center;
    z-index: 2;
}
.mpb_monitor tr:first-child th {
    top: 0;
}
.mpb_monitor tr:nth-child(2) th {
    top: 2em;
}
.mpb_monitor tr:nth-child(3) th {
    top: 4em;
}
.mpb_monitor tr:first-child th:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
}
.mpb_monitor td:first-child {
    position: sticky;
    left: 0;
    text-align: center;
    background-color: #fff;
    z-index: 1;
}
.mpb_monitor td {
    text-align: center;
}

.mpb_monitor .dot {
    display: inline-block;
    border-radius: 50%;
    height: 1.5em;
    width: 1.5em;
}

.mpb_monitor .text-warning {
    color: red;
    font-weight: bold;
}
</style>
